import { faLongArrowRight as lightLongArrowRight } from "@jewlr/pro-light-svg-icons/faLongArrowRight"
import {
  Box,
  Button,
  Flex,
  FontAwesomeIcon,
  Typography,
} from "@jewlr/storybook/core"
import styled from "styled-components"

export const Border = styled(Box)`
  ${({ theme }) => `
  border: solid 1px ${theme.colors.grey[65]};
  height: 1px;
  margin: auto;
  clear:both;
`}
`

export const Content = styled(Box).attrs((props) => ({
  fontSize: "16px",
  fontWeight: "300",
  lineHeight: "22px",
  ...props.theme.helpdesk.content,
  ...props,
}))``

export const SearchBox = styled(Flex).attrs((props) => ({
  my: { _: 1, tablet: 0 },
  px: 3,
  py: 4,
  ...props.theme.helpdesk.searchBox,
}))`
  ${({ theme }) => `
    box-sizing: border-box;
    background-color: ${theme.helpdesk.box.background};
    color: ${theme.helpdesk.box.text};
    flex-direction: column;
    text-align:left;
    word-break : break-word;
    width: 100%;
    display: inherit;
    justify-content: ${(props) =>
      props.simple} ? "flex-start" : "space-between";
  `}
`

export const TitleBorder = styled(Typography).attrs((props) => ({
  as: "h1",
  borderBottom: "solid 1px",
  color: props.theme.colors.black,
  fontSize: { _: props.theme.fontSizes[24], tablet: "32px" },
  fontWeight: "300",
  mx: "auto",
  my: 0,
  pb: "24px",
  textAlign: "center",
  width: { _: "70%", tablet: "100%" },
  ...props.theme.helpdesk.titleBorder,
}))``

export const Title = styled(Typography).attrs((props) => ({
  as: "h2",
  display: "inline-block",
  ...props.theme.helpdesk.title,
}))`
  ${({ theme }) => `
    color: ${theme.colors.black};
    font-size: ${theme.fontSizes[20]};
    font-weight: normal;
    text-align: center;
    width: 100%;
    padding: 0px;
    ${theme.mediaQueries.tablet`
      font-size: ${theme.fontSizes[24]};
    `}
  `}
`

export const SubTitle = styled(Typography).attrs((props) => ({
  color: props.theme.helpdesk.box.text,
  fontSize: "20px",
  mb: props.theme.space[3],
  ...props,
}))`
  line-height: 24px;
  ${(props) => props.theme.helpdesk.subTitle}
`

export const ReadmoreLink = styled(Box).attrs((props) => ({
  color: props.selected ? "grey.35" : props.theme.helpdesk.box.text,
  fontSize: props.theme.fontSizes[16],
  fontWeight: props.selected ? "700" : "normal",
}))`
  ${({ theme }) => `
    text-decoration: ${theme.helpdesk.link.underline};
    :hover {
      text-decoration: ${theme.helpdesk.link.underline};
    }
    ${theme.mediaQueries.tablet`
      text-decoration: ${theme.helpdesk.readMoreLink};
    `}
  `}
  cursor: pointer;
  text-align: left;
  ${(props) => props.theme.helpdesk.readMoreLink}
`
export const LinkArrow = styled(FontAwesomeIcon).attrs(() => ({
  icon: lightLongArrowRight,
}))`
  ${({ theme }) => `
    display: ${theme.helpdesk.link.arrow};
    margin-right: 8px;
  `}
`
export const ButtonLink = styled(Button).attrs((props) => ({
  fontSize: 14,
  fontWeight: "700",
  letterSpacing: "tracked",
  outline: props.theme.helpdesk.link.outline,
  px: 5,
  py: 1,
  ...props.theme.helpdesk.buttonLink,
}))`
  ${({ theme }) => `
    text-decoration: ${theme.helpdesk.link.underline};
  `}
`

export const LinkButton = styled(Box).attrs((props) => ({
  as: "a",
  bg: "white",
  border: "solid 1px black",
  color: "black",
  display: "inline-block",
  fontSize: "16px",
  fontWeight: "bold",
  p: { _: "10px 56px", tablet: "16px 56px" },

  ...props,
}))`
  border-radius: 0;
  line-height: 16px;
  :focus {
    opacity: 0.7;
    outline: none;
  }
`
export const TitleHelpTopic = styled(Typography).attrs(() => ({
  as: "h1",
}))`
  ${({ theme }) => `
  color: ${theme.colors.black};
  font-size: 28px;
  font-weight: 500;
  linke-height: 33px;
  text-align: center;
  `}
`
export const Container = styled(Box)`
  ${({ theme }) => `
    h1 {
      color: ${theme.colors.black};
    font-size: 20px;
    font-weight: normal;
    line-height:24px;
    font-weight:700;
    margin-bottom:16px;

    }

    h2 {
      font-size: 34px;
      font-weight: 500;
      line-height: 41px;
      color: ${theme.colors.black};
    }

    h3 {
      font-size: 24px;
      font-weight: normal;
      line-height: 31px;
      color: ${theme.colors.neutral};
      ${theme.mediaQueries.tablet`
        line-height: 40px;
      `}
    }

    h4 {
      font-size: 22px;
      font-weight: normal;
      line-height: 31px;
      color: ${theme.colors.neutral};
      ${theme.mediaQueries.tablet`
        font-size: 30px;
        line-height: 36px;
      `}
    }

    h5 {
      font-size: 18px;
      font-weight: 700;
      line-height: 22px;
      color:${theme.colors.black};
      ${theme.mediaQueries.tablet`
        font-size: 28px;
        font-weight: 500;
        line-height: 33px;
      `}
    }

    .subheadings {
      font-size: 12px;
      font-weight: 500;
      line-height: 14px;
      letter-spacing: 2.06;
      color: ${theme.colors.grey[65]};
    }

    p {
       font-size: 16px;
       font-weight: 300;

    }

    .articleCard {
      font-size: 14px;
      font-weight: 300;
      line-height: 18px;
      letter-spacing: 2;
      color: ${theme.colors.grey[65]};
      ${theme.mediaQueries.tablet`
        font-size: 17px;
        line-height: 22px;
        letter-spacing: 3;
      `}
    }

    table {
      td {
        font-size: 12px;
        font-weight: 500;
        line-height: 14px;
        letter-spacing: 0.86;
        color: ${theme.colors.grey[65]};
        ${theme.mediaQueries.tablet`
          font-size: 16px;
          line-height: 19px;
          letter-spacing: 0.35;
        `}
      }
    }

    a {
      font-weight: 700;
      line-height: 17px;
      letter-spacing: 0.35;
       color: ${theme.helpdesk.searchBoxlink.color};
       text-decoration:${theme.helpdesk.searchBoxlink.underline};
      ${theme.mediaQueries.tablet`
        font-weight: 500;
        line-height: 19px;
        letter-spacing: 0.4;
      `}
    }
  `}
`
export const DividerText = styled(Typography).attrs(() => ({
  as: "h2",
}))`
  ${({ theme }) => `
    background-color: white;
    color: ${theme.helpdesk.box.text};
    font-size: ${theme.fontSizes[24]};
    font-weight: normal;
    margin: 0 auto;
    margin-top: -18px;
    text-align: center;
    width: 80%;
    ${theme.mediaQueries.tablet`
      font-size: ${theme.fontSizes[26]};
      width: 60%;
    `}
  `}
`

export const DividerTextBorder = styled(Box)`
  ${({ theme }) => `
   border-bottom: solid 1px;
   margin: auto;
    width: 80%;
    ${theme.mediaQueries.tablet`
      font-size: ${theme.fontSizes[26]};
      border-top: solid 1px;
      border-bottom: 0;
      width: 45%;
    `}
  `}
`

export const SideMenuTitle = styled(Typography).attrs((props) => ({
  as: "h4",
  color: props.theme.helpdesk.box.text,
  fontSize: { _: props.theme.fontSizes[16], tablet: props.theme.fontSizes[18] },
  fontWeight: "bold",
  ...props.theme.helpdesk.sideMenuTitle,
}))`
  cursor: pointer;
  display: inline-block;
  text-align: left;
  width: 90%;
`

export const SideMenuSubTitle = styled(Typography).attrs((props) => ({
  fontSize: { _: props.theme.fontSizes[16], tablet: props.theme.fontSizes[16] },
  ...props.theme.helpdesk.sideMenuTitle,
}))`
  cursor: pointer;
  display: inline-block;
  font-weight: normal;
  text-align: left;
  padding-left: 24px;
  width: 100%;
  padding-top: 8px;
  padding-bottom: 8px;
`
export const SearchBlock = styled(Box).attrs((props) => ({
  display: "flex",
  flex: { _: 1, tablet: "0 0 50%" },
  flexWrap: "wrap",
  gutter: { tablet: 2 },
  minHeight: { _: "160px", tablet: "220px" },
  ...props,
}))``

export const SearchFlex = styled(Flex).attrs((props) => ({
  flexDirection: { _: "column", tablet: "row" },
  flexWrap: "wrap",
  gutter: { _: 0, tablet: 2 },
  mb: 6,
  mx: { tablet: 3 },
  ...props,
  ...props.theme.helpdesk.searchFlex,
}))``

export const CategoryItemsContainer = styled(Flex).attrs((props) => ({
  flexDirection: { _: "column", tablet: "inherit" },
  flexWrap: "wrap",
  gutter: { _: 0, tablet: 2 },
  ...props.theme.helpdesk.categoryItemsContainer,
}))``
